import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "trending-5, chart, analytics" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M16.0156 9.14062L15.7111 8.83609C14.93 8.05504 13.6637 8.05504 12.8827 8.83609L11.0742 10.6445C10.4809 11.2378 9.51906 11.2378 8.92578 10.6445V10.6445C8.33251 10.0513 7.37062 10.0513 6.77734 10.6445L3.125 14.2969M3.125 3.125V14.2969M16.875 16.875H5.125C4.02043 16.875 3.125 15.9796 3.125 14.875V14.2969",
        stroke: "#8E8E93",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ])))
}
export default { render: render }